<template>
  <div> <el-alert
    class="alert"
    type="success"
    :closable="false"
    effect="dark"><span class="span-senha">
      {{mensagem}}
    </span>
  </el-alert>
  </div>
</template>
<script>
export default {
  props: {
    mensagem: String
  }
}
</script>
<style>
.alert{
  width: 370px;
  height: 90px;
  display: flex;
  background-color: #01CB3F !important;
}
  .span-senha {
    text-align: left;
    letter-spacing: 0;
    color: #FFFFFF;
    opacity: 1;
    font-size: 15px;
    line-height: 20px;
  }
</style>
